<template src="./NotificationDialog.html"></template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        visible: { type: Boolean, required: true },
        title: { type: String, default: "Notification" },
        message: { type: String, required: true },
        button: { type: String, default: "Ok" },
        height: { type: Number, default: 150 }
    },
    emits: ["update:visible"],
    computed: {
        popupVisible: {
            get() {
                return this.visible;
            },
            set(v: boolean) {
                this.$emit("update:visible", v);
            }
        }
    },
    methods: {
        close() {
            this.$emit("update:visible", false);
        }
    }
});
</script>
